/*
    Used to determine if a component is within the viewport - based on its Ref
*/

import { useEffect, useState, useRef, RefObject } from 'react';

interface UseIsVisibleOptions {
    threshold?: number | number[];
    rootMargin?: string;
}

export function useIsVisible(
    ref: RefObject<HTMLElement> | null,
    options?: UseIsVisibleOptions
): boolean {
    const [isIntersecting, setIntersecting] = useState(false);
    const optionsRef = useRef(options);
    optionsRef.current = options;

    useEffect(() => {
        if (!ref?.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIntersecting(entry.isIntersecting);
            },
            {
                threshold: optionsRef.current?.threshold,
                rootMargin: optionsRef.current?.rootMargin,
            }
        );

        observer.observe(ref.current);

        return () => {
            observer.disconnect();
        };
    }, [ref]);

    return isIntersecting;
}
